import React, { useEffect } from 'react'
import Icon from 'components/Icon'
import messages from './messages'
import { FormattedMessage } from 'react-intl'

const Draft = ({ attribute, state, onChange }) => {
  const { key, name, options, title, disabled, hidden} = attribute
  const { selected } = state || { selected: options[0] || false }

  const onClick = () => {
    if (options.includes(!selected)) {
      onChange({ ...state, selected: !selected })
    }
  }

  return (
    <fieldset className={`space-y-2 ${hidden ? 'hidden' : 'display-block'}`}>
      <div className="flex space-x-4 items-center">
        <div className="flex gap-2 items-center">
          <p className="text-xs font-medium text-gray-600 uppercase tracking-wider">
            { name }
          </p>
          {title && (
            <Icon
              icon="info-circle"
              title={title}
              className="text-primary hover:text-secondary"
            />
          )}
        </div>

        {/* Reveres "selected" boolean so that if toggled off it will be a draft */}
        <button disabled={disabled} type="button" className={`shrink-0 group relative rounded-full inline-flex items-center justify-center h-5 w-10 cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary ${disabled ? 'cursor-not-allowed' : ''}`} aria-pressed="false" onClick={onClick}>
          <span aria-hidden="true" className="pointer-events-none absolute bg-white w-full h-full rounded-sm"></span>
          <span aria-hidden="true" className={`${!selected ? 'bg-primary' : 'bg-gray-200'} pointer-events-none absolute h-4 w-9 mx-auto rounded-full transition-colors ease-in-out duration-200`}></span>
          <span aria-hidden="true" className={`${!selected ? 'translate-x-5' : 'translate-x-0'} pointer-events-none absolute left-0 inline-block h-5 w-5 border border-gray-200 rounded-full bg-white shadow transform ring-0 transition-transform ease-in-out duration-200`}></span>
        </button>
      </div>
      {selected &&
        <span className="rounded-sm bg-yellow-50 p-3 block max-w-md">
          <div className="flex">
            <div className="shrink-0">
              <Icon icon="info-circle" className="text-yellow-600" />
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-medium text-yellow-600 whitespace-pre-line">
                <FormattedMessage {...messages.selected}/>
              </h3>
            </div>
          </div>
        </span>
      }
    </fieldset>
  )
}

export default Draft
